import { Component } from '@angular/core';
import { LoaderService } from 'libs/core/src/lib/service/loading.service';
import { ScreeningListComponent } from 'libs/shared/src/lib/component/screening/list/list.component';

@Component({ standalone: false, selector: 'app-screening-list', templateUrl: './list.component.html' })
export class CustomScreeningListComponent extends ScreeningListComponent {
  constructor(protected loaderService: LoaderService) {
    super(loaderService);
  }
}
